import { apiTypes } from 'shared/consts/handbooksApiTypes';

const tabsTitles = {
  smsv_incident_type: 'Типы событий',
  smsv_device_models: 'Модели оборудования ИСПВ',
  smsv_device: 'Оборудование наблюдения за водителем'
};

const config = {
  schema: '',
  title: 'ИСПВ',
  multipleConfig: true,
  tabsTitles,
  defaultSelectedTab: 'smsv_incident_type',
  tabs: {
    smsv_incident_type: {
      schema: '',
      table: 'smsv_incident_type',
      title: tabsTitles.smsv_incident_type,
      apiType: apiTypes.REPORT_API,
      elemsOnPage: 100,
      connections: {},
      keyField: 'incident_type_id',
      fields: [
        {
          name: 'incident_type_id',
          title: 'ID записи',
          index: true,
          type: 'number',
          width: '120px',
          disableFilter: true,
        },
        {
          name: 'incident_type_code',
          title: 'Код события',
          type: 'number',
        },
        {
          name: 'incident_type_name',
          title: 'Название',
          type: 'text',
        },
        {
          name: 'incident_type_short_name',
          title: 'Короткое название',
          type: 'text',
        },
        {
          name: 'incident_type_color',
          title: 'Цвет',
          type: 'color',
          disableFilter: true,
        },
        {
          name: 'incident_type_value',
          title: 'Вес (оценка) события',
          type: 'number',
          minValue: 1,
          maxValue: 5,
        },
      ],
      makeIdOnInsert: true,
      defaultSort: {
        field: 'id',
        direction: 'desc',
      },
      newTemplate: {
        incident_type_id: null,
        incident_type_code: null,
        incident_type_name: null,
        incident_type_short_name: null,
        incident_type_color: '#000000',
        incident_type_value: 0,
      },
      import: {
        header: [
          {
            title: 'incident_type_id',
            field: 'incident_type_id'
          },
          {
            title: 'incident_type_code',
            field: 'incident_type_code'
          },
          {
            title: 'incident_type_name',
            field: 'incident_type_name'
          },
          {
            title: 'incident_type_short_name',
            field: 'incident_type_short_name'
          },
          {
            title: 'incident_type_color',
            field: 'incident_type_color'
          },
          {
            title: 'incident_type_value',
            field: 'incident_type_value'
          },
        ],
        example: '1;1;ASD;ASD;#00000;4'
      },
    },
    smsv_device_models: {
      schema: '',
      table: 'smsv_device_models',
      title: tabsTitles.smsv_device_models,
      apiType: apiTypes.REPORT_API,
      elemsOnPage: 100,
      connections: {},
      keyField: 'device_models_id',
      fields: [
        {
          name: 'device_models_id',
          title: 'ID записи',
          index: true,
          type: 'number',
          width: '120px',
          disableFilter: true,
        },
        {
          name: 'device_models_type',
          title: 'Тип оборудования',
          type: 'list',
          values: [
            { key: '1', value: 'Оборудование наблюдения за водителем' }
          ]
        },
        {
          name: 'device_models_model',
          title: 'Модель',
          type: 'text'
        }
      ],
      makeIdOnInsert: true,
      defaultSort: {
        field: 'id',
        direction: 'desc',
      },
      newTemplate: {
        device_models_id: null,
        device_models_type: null,
        device_models_model: null
      },
      import: {
        header: [
          {
            title: 'device_models_id',
            field: 'device_models_id'
          },
          {
            title: 'device_models_type',
            field: 'device_models_type'
          },
          {
            title: 'device_models_model',
            field: 'device_models_model'
          },
        ],
        example: '1;ASD;ASD'
      },
    },
    smsv_device: {
      schema: '',
      table: 'smsv_device',
      title: tabsTitles.smsv_device,
      apiType: apiTypes.REPORT_API,
      elemsOnPage: 100,
      connections: {
        vehicles: {
          apiType: apiTypes.REPORT_API,
          table: 'vehicles',
          fields: ['depot_number'],
          format: (elem: any) => elem['name'],
          index: 'id',
          autocomplete: true,
        },
        models: {
          apiType: apiTypes.REPORT_API,
          table: 'smsv_device_models',
          fields: ['device_models_model'],
          format: (elem: any) => elem['name'],
          index: 'id',
          autocomplete: true,
        }
      },
      keyField: 'device_id',
      fields: [
        {
          name: 'device_id',
          title: 'ID записи',
          index: true,
          type: 'number',
          width: '120px',
          disableFilter: true,
        },
        {
          name: 'vehicle_id',
          title: 'Гаражный номер транспортного средства',
          type: 'number',
          required: true,
          connection: 'vehicles',
          id_type: 'number',
        },
        {
          name: 'device_models_id',
          title: 'Модель',
          type: 'text',
          connection: 'models',
        },
        {
          name: 'device_serial_number',
          title: 'Серийный номер оборудования',
          type: 'text'
        }
      ],
      makeIdOnInsert: true,
      defaultSort: {
        field: 'id',
        direction: 'desc',
      },
      convertFunctions: {
        device_models_id: (value: any) => value && Number(value)
      },
      newTemplate: {
        device_id: null,
        vehicle_id: null,
        device_models_id: null,
        device_serial_number: null,
      },
      import: {
        header: [
          {
            title: 'device_id',
            field: 'device_id'
          },
          {
            title: 'vehicle_id',
            field: 'vehicle_id'
          },
          {
            title: 'device_models_id',
            field: 'device_models_id'
          },
          {
            title: 'device_serial_number',
            field: 'device_serial_number'
          }
        ],
        example: '1;ASD;ASD'
      },
    }
  }
};

export default config;